import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseProductFee: null,
  franchiseProductFees: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseProductFeeReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEPRODUCTFEE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEPRODUCTFEE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEPRODUCTFEE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    case actionTypes.FRANCHISEPRODUCTFEE_LISTRESET: {
      return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
    }
    default: {
      return state;
    }
  }
};

export default franchiseProductFeeReducer;
